// How long a notistack outcome report stays on screen. The snackbar provider's 3s default is
// too short to read a multi-line report; both pair with a dismiss button.
export const OUTCOME_SNACKBAR_MS = 5000;
// A failure sends the user back to what they were doing, so it holds far longer than a success.
export const FAILURE_SNACKBAR_MS = 30000;
